module.exports = __webpack_public_path__ + "img/zhuanzhen.1b4d48a6.png";